import React from 'react';
import { Link } from 'react-router';
import { translate } from 'react-i18next';
import classnames from 'classnames';
import { isBrowser } from 'react-device-detect';
import { get } from 'lodash';

import SocialGroup from 'components/molecules/SocialGroup';

import JustsleepLogo from 'images/icons/logo-justsleep-short.svg';

import styles from './index.css';

const Footer = ({
	t,
	tel,
	fax,
	address,
	contactUs,
	bookingCode,
	mapLink,
	hotelList,
	hotelData,
	hotel,
	lanRoute,
	registrationNumber,
}) => {
	const currentYear = new Date().getFullYear();

	const contactLan = lan => {
		switch (lan) {
		case 'tw':
			return 'zh-tw';
		case 'cn':
			return 'zh-cn';
		case 'kr':
			return 'ko';
		case 'jp':
			return 'ja';
		default:
			return lan;
		}
	};

	return (
		<footer className={styles.footer}>
			<div className={styles.top}>
				<SocialGroup className={styles.socialGroup} />
				<div className={styles.info}>
					<div className={styles.contact}>
						<a
							href={`https://event.silkshotelgroup.com/ContactUs/${contactLan(
								lanRoute,
							)}/${bookingCode}`}
							target="_blank"
						>
							{contactUs}
						</a>
						<a href={`tel:${tel.replace(/ /g, '')}`} className={styles.tel}>
							{tel}
						</a>
						<a href="/">{fax}</a>
						<a href={mapLink} target="_blank" className={styles.address}>
							{address}
						</a>
					</div>
					{registrationNumber && (
						<p className={styles.registrationNumber}>
							{t('registrationNumber')}：{registrationNumber}
						</p>
					)}
				</div>
			</div>
			<div className={styles.middle}>
				<div className={classnames(styles.hotels, { [styles.en]: lanRoute === 'en' })}>
					{hotelList.map(hotelKey => (
						<span
							key={hotelKey}
							className={classnames({
								[styles.isBrowser]: isBrowser,
							})}
						>
							<Link to={`/${hotelKey}`}>{get(hotelData[hotelKey], 'name', 'default-hotel')}</Link>
						</span>
					))
					}
				</div>
				<div className={styles.info}>
					<div className={styles.contact}>
						<a
							href={`https://event.silkshotelgroup.com/ContactUs/${contactLan(
								lanRoute,
							)}/${bookingCode}`}
							target="_blank"
						>
							{contactUs}
						</a>
						<a href={`tel:${tel.replace(/ /g, '')}`} className={styles.tel}>
							{tel}
						</a>
						<a href="/">{fax}</a>
						<a href={mapLink} target="_blank" className={styles.address}>
							{address}
						</a>
					</div>
					{registrationNumber && (
						<p className={styles.registrationNumber}>
							{t('registrationNumber')}：{registrationNumber}
						</p>
					)}
				</div>
			</div>
			<div className={styles.bottom}>
				<div className={styles.logo}>
					<JustsleepLogo viewBox="0 0 289 60" width="100%" height="25px" />
				</div>
				<div className={styles.text}>
					<div className={styles.copyright}>
						<span>Copyright</span>
						<span role="img" aria-label="copyright">
							©
						</span>
						<a
							href={`https://www.silkshotelgroup.com/${lanRoute === 'kr' ? 'en' : lanRoute}/`}
							target="_blank"
						>
							{currentYear} Silks Hotel Group
						</a>
					</div>
					<Link
						to={hotel === 'main' ? '/privacy' : `/${hotel}/${lanRoute}/privacy`}
						className={styles.privacy}
					>
						{t('privacy')}
					</Link>
				</div>
			</div>
		</footer>
	);
};

export default translate('footer')(Footer);



// WEBPACK FOOTER //
// ./src/components/organisms/Footer/component.js